// not found page
import React from "react";
import tw from "tailwind-styled-components";
import Images from "../Images";

const NotFoundModel = () => {
  return (
    <Wrapper>
      <Figure>
        <img src={Images.NotFound} alt="error image" />
      </Figure>
      <Title>Page Not Found</Title>
    </Wrapper>
  );
};

const Wrapper = tw.div`w-11/12 max-w-3xl mx-auto my-8 flex flex-col items-center`;
const Title = tw.h2`text-xl md:text-2xl text-gray-600 font-bold text-center mt-4`;
const Figure = tw.div`w-64 mx-auto mb-4`;

export default NotFoundModel;
